var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_6018)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_356_6018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17761 10.6667H27.7035L28.4757 7.61905H9.26642V4.57143H30.4556C30.6904 4.57143 30.9221 4.62425 31.133 4.72585C31.344 4.82745 31.5287 4.97516 31.6731 5.15777C31.8176 5.34038 31.9179 5.55307 31.9665 5.77967C32.0151 6.00628 32.0108 6.24084 31.9537 6.46552L28.0927 21.7036C28.009 22.0331 27.8162 22.3256 27.5448 22.5346C27.2733 22.7436 26.9389 22.8571 26.5946 22.8571H4.63321C4.22361 22.8571 3.83078 22.6966 3.54115 22.4108C3.25152 22.1251 3.08881 21.7375 3.08881 21.3333V3.04762H0V0H4.63321C5.04281 0 5.43564 0.160544 5.72527 0.446313C6.0149 0.732083 6.17761 1.11967 6.17761 1.52381V10.6667ZM6.17761 32C5.35841 32 4.57276 31.6789 3.9935 31.1074C3.41423 30.5358 3.08881 29.7607 3.08881 28.9524C3.08881 28.1441 3.41423 27.3689 3.9935 26.7974C4.57276 26.2259 5.35841 25.9048 6.17761 25.9048C6.99682 25.9048 7.78247 26.2259 8.36173 26.7974C8.94099 27.3689 9.26642 28.1441 9.26642 28.9524C9.26642 29.7607 8.94099 30.5358 8.36173 31.1074C7.78247 31.6789 6.99682 32 6.17761 32ZM24.7105 32C23.8913 32 23.1056 31.6789 22.5263 31.1074C21.9471 30.5358 21.6216 29.7607 21.6216 28.9524C21.6216 28.1441 21.9471 27.3689 22.5263 26.7974C23.1056 26.2259 23.8913 25.9048 24.7105 25.9048C25.5297 25.9048 26.3153 26.2259 26.8946 26.7974C27.4738 27.3689 27.7993 28.1441 27.7993 28.9524C27.7993 29.7607 27.4738 30.5358 26.8946 31.1074C26.3153 31.6789 25.5297 32 24.7105 32Z",
    fill: "#BDBDBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_6018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_356_6018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5556,
    height: 35.5556,
    fill: "white",
    transform: "translate(-1.77778 -1.77777)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.1a81a0ef75692d777f36a5199f90b559.svg";
export { ForwardRef as ReactComponent };